import SearchThisArea from '../components/search-this-area';
import DrawYourSearch from '../components/draw-your-search';
import { locationSources } from '../layers';
import Logger from '../../logging/logger';

const onMapClick = ( ctx, event ) => {
    const features = ctx.map.queryRenderedFeatures( event.point, {
        validate: ctx.debug,
    } );

    if ( !features || features.length === 0 ) {
        return;
    }

    const feature = features[ 0 ];
    const featureType = feature.properties.type;

    const isLocationType = locationSources.includes( featureType );

    const previouSearch = new URLSearchParams( ctx.previousSearchState );

    const allowClicks = () => {
        if ( isLocationType && previouSearch.has( 'area' ) && !ctx.activeComponents.has( SearchThisArea.id ) ) {
            return false;
        }
        if ( ctx.activeComponents.has( DrawYourSearch.id ) ) {
            return false;
        }
        if ( ctx.activeComponents.has( SearchThisArea.id ) && feature.source !== 'properties' ) {
            return false;
        }
        return true;
    };

    if ( !allowClicks() ) {
        return;
    }

    Logger.info( '[map] Map Feature Click', feature );

    const featureEvent = new CustomEvent( `twc:mapsearch:click-${featureType}`, {
        bubbles: true,
        detail: {
            originalEvent: event,
            feature: feature,
        },
    } );

    ctx.root.dispatchEvent( featureEvent );
};

export default onMapClick;
